import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Table, Row, Col } from 'reactstrap';
import { Loader } from '../common/Loader';
import { getReport } from '../../actions/DesignMaster';
import _ from 'lodash';
import moment from 'moment'
import { convertDate } from '../../helper';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactExport from 'react-export-excel';
import { ReportDownload } from '../../config/masterData';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Report = ({ activeTab, showReportTab, getReport, selectedShutterDesignData, ...props }) => {
    const [isLoader, setLoader] = useState(false);
    const [reportData, setReportData] = useState([]);
    const { UserName, ShutterDesignCalculationId, CreatedDate, SelectedStage, SelectedActuation } = selectedShutterDesignData


    useEffect(() => {
        setLoader(true)
        getReport(ShutterDesignCalculationId, res => {
            if (res.status === 200) {
                setReportData(res.data.Data)
            }
            setLoader(false)
        })
    }, [])

    const displayReportData = () => {
        if (reportData && reportData.TenderVsPostOrderReport && reportData.TenderVsPostOrderReport.length) {
            const tableData = reportData.TenderVsPostOrderReport.map((data, index) => {
                return (
                    <tr key={index}>
                        <td> {data.Label.replace(/_/g, ' ')}</td>
                        <td>{data.Tender} </td>
                        <td> {data.PostOrder} </td>
                        <td> {data.Difference} </td>
                    </tr>
                )
            });
            return tableData
        }
    }

    const dataFormatter = (data) => data ? data : '-'

    const renderColumn = (fileName) => {
        const tableData = reportData.TenderVsPostOrderReport && reportData.TenderVsPostOrderReport.map((data, index) => {
            data.Label = data.Label.replace(/_/g, ' ')
            return data
        })
        return returnExcelColumn(ReportDownload, tableData && tableData)
    }

    const returnExcelColumn = (data = [], TempData) => {
        return (<ExcelSheet data={TempData} name={'Report'}>
            {data && data.map((ele, index) => <ExcelColumn key={index} label={ele.label} value={ele.value} style={ele.style} />)}
        </ExcelSheet>);
    }
    return (
        <div>
            {isLoader && <Loader />}
            <div className="shutter-design">
                {true &&
                    <div className='d-flex justify-content-end mt-3'>

                        <ExcelFile filename={'Report'} fileExtension={'.xls'} element={
                            <button type="button" disabled={false} className={'user-btn'}><div className="download"></div>DOWNLOAD</button>
                        }>
                            {renderColumn('Report')}
                        </ExcelFile>
                    </div>
                }
                <div className="form-heading">
                    <h2>Report</h2>
                    <Row className={"mb-3"}>
                        <Col md="3">
                            <p>Date</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{moment(CreatedDate).format("DD-MM-YYYY")}</p>
                        </Col>
                        <Col md="3">
                            <p>User Name</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{dataFormatter(UserName)}</p>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col md="3">
                            <p>Stage</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{dataFormatter(SelectedStage)}</p>
                        </Col>
                        <Col md="3">
                            <p>Actuation Type</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{dataFormatter(SelectedActuation)}</p>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col md="3">
                            <p>Tender Created/Modified By</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{dataFormatter(reportData.TenderCreatedOrModifiedBy)}</p>
                        </Col>
                        <Col md="3">
                            <p>Tender Created/Modified On</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{reportData.TenderCreateOrModifiedOn ? convertDate(reportData.TenderCreateOrModifiedOn) : '-'}</p>
                        </Col>
                    </Row>
                    <Row className={"mb-3"}>
                        <Col md="3">
                            <p>Post Created By</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{dataFormatter(reportData.PostOrderCreatedBy)}</p>
                        </Col>
                        <Col md="3">
                            <p>Post Created On</p>
                        </Col>
                        <Col md="1">:</Col>
                        <Col md="2">
                            <p>{reportData.PostOrderCreatedOn ? convertDate(reportData.PostOrderCreatedOn) : '-'}</p>
                        </Col>
                    </Row>
                    {/* <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="download-table-xls-button"
                        table="table-to-xls"
                        filename="tablexls"
                        sheet="tablexls"
                        buttonText="Download as XLS" /> */}
                    <Table bordered hovers id="table-to-xls">
                        <thead>
                            <tr>
                                <th>Parameters</th>
                                <th>Tender</th>
                                <th>Post Order</th>
                                <th>Difference</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayReportData()}
                        </tbody>
                    </Table>

                </div>
            </div>
        </div>

    )
}

export default connect(null, { getReport })(Report)